import {Icon} from 'semantic-ui-react';
import React from 'react';
import {withRouter} from 'react-router';
import {get as _get} from 'lodash';

import DefaultForm from '@appComponents/DefaultForm';
import {getLink} from '@appComponents/Link';
import {
    REPORT_MULTIPLE_AS_WORKING_AND_INVOICEABLE_FAILURE_MESSAGE,
    REPORT_MULTIPLE_AS_WORKING_AND_INVOICEABLE_SUCCESS_MESSAGE,
    reportMultipleAsWorkingAndInvoiceableErrorHandler,
    reportMultipleAsWorkingAndInvoiceableResponseHandler,
}
    from '@modules/events/utils/reportMultipleAsWorkingAndInvoiceableHelper';
import {refetchQueryByName} from '@utils/apollo';

class ReportMultipleEventsAsWorkingForm extends DefaultForm {
    prepareDataForSubmit = (data) => {
        data.events = this.props.formParams.optionsVariables.events;

        return data;
    };

    redirectToEventSchedulingPage = () => (
        this.props.history.push(getLink('events.index'))
    );

    renderSaveButton = () => {
        const yesButtonProps = {
            content: 'Yes',
            icon: <Icon className='check icon' name='check' />,
            color: 'green',
        };

        return super.renderSaveButton(yesButtonProps);
    };

    renderCancelButton = () => {
        const noButtonProps = {
            content: 'No',
            color: 'red',
            icon: <Icon className='times icon' name='times' />,
        };

        return super.renderCancelButton(noButtonProps);
    };

    errorHandler = () => {
        reportMultipleAsWorkingAndInvoiceableErrorHandler(
            'eventsIndex',
            REPORT_MULTIPLE_AS_WORKING_AND_INVOICEABLE_FAILURE_MESSAGE
        );
        this.redirectToEventSchedulingPage();
    };

    componentDidMount = () => {
        this.setCreateErrorCallback(() => {
            this.errorHandler();
        });

        this.setCreateSuccessCallback((response) => {
            reportMultipleAsWorkingAndInvoiceableResponseHandler(
                _get(response, 'data.reportWorkingInvoiceableEvents', false),
                'eventsIndex',
                REPORT_MULTIPLE_AS_WORKING_AND_INVOICEABLE_SUCCESS_MESSAGE
            );
            refetchQueryByName('EventScheduleQuery');
            this.redirectToEventSchedulingPage();
        });
    };
}

export default withRouter(ReportMultipleEventsAsWorkingForm);
